import React from 'react'
import moment from 'moment'
import Swiper from 'react-id-swiper'
import Link from '../components/Link'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'

import { get, getCount } from '../store/reducers/news'
//import Carousel from 'react-bootstrap/Carousel'

const params = {
  //effect: 'coverflow',
  grabCursor: false,//true
  centeredSlides: true,
  slidesPerView: 'auto',
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    hide: true
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false
  }
  /*coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 500,
    modifier: 1,
    slideShadows: false
  },
  breakpoints: {
    1024: {
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 0.5,
        slideShadows: false
      }
    },
    667: {
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 0,
        slideShadows: false
      }
    }
  }*/
}
/*_id: "59ef12563f7b645ba2a1d88f"
locale: "ru"
image: "https://frontmfc.dev-vt2b.ru/files/5a2d817905648c7b0d2744b4/image/"
description: "<p><b><font color="#ff0000">Оксана</font> </b>имя смелой девушки, которая первой согласилась принять участие в проекте&nbsp;</p><p><b><font color="#ff0000">18 апреля 2016</font> </b>было создано сообщество <a href="https://www.facebook.com/meetforcharity/" target="_blank">Meet For Charity</a> в фейсбуке&nbsp;</p><p><font color="#ff0000"><b>Date For Charity&nbsp;</b></font>именно так назывался проект изначально. Да, мы разыгрывали благотворительные свидания</p><p><b><font color="#ff0000">Сергей Капков</font>&nbsp;</b>поменял ход истории проекта. За встречу с ним были привлечены рекордные на тот момент 140 000 рублей на благотворительность&nbsp;</p><p><b><font color="#ff0000">Сентябрь 2016&nbsp;</font></b>11:37, Кремниевая долина, один из многочисленных Старбаксов, Date For Charity меняется на Meet For Charity и, начиная с этого момента, проект становится таким, каким вы знаете его сейчас</p><p><b><font color="#ff0000">Гор Нахапетян, Митя Хрусталёв, Алёна Долецкая, Кирилл Серебренников</font></b>&nbsp;неполный список тех, кто первыми отправились на благотворительные встречи Meet For Charity</p><p><b style="color: rgb(255, 0, 0);">Полмиллиона </b>на благотворительность – именно за такую сумму "ушла с молотка" встреча с Михаилом Кучментом в поддержку фонда ОРБИ</p><p><font color="#ff0000"><b>16 января 2017</b>&nbsp;</font>на DLD конференции в Мюнхене Meet For Charity занял <a href="https://te-st.ru/2017/02/09/meet-for-charity-winner-cerprize-2017/" target="_blank">3-е призовое</a> место премии CERprize, вручаемой лучшим социальным проектам</p><p><font color="#ff0000" style="font-weight: bold;">Первый миллион,&nbsp;</font><font>а точнее 1 200 000 рублей – мы привлекли за встречу с Дмитрием Гришиным, CEO Mail.ru Group, в поддержку фонда "Друзья", а затем были 1 400 000 рублей за встречу с Никой Белоцерковской, издаетелем журнала Sobaka.ru и любителем #кофекофе, в поддержку благотворительной организации "Ночлежка"&nbsp;</font></p><p><b><font color="#ff0000">11.12.2017&nbsp;</font></b>Мы запустили <a href="https://meetforcharity.today">meetforcharity.today</a>&nbsp;</p>"
title: "MFC в цифрах и фактах"
city:
_id: "59c264aa3a8eb0652ed7a7f2"
is: {updated: "2017-09-20T12:52:58.176Z", created: "2017-09-20T12:52:58.176Z", enabled: true}
countryId: "59c2647a3a8eb0652ed7a7f0"
localeNames: [{…}]
__v: 0
__proto__: Object
created: "2017-12-08T09:00:58.765Z"
meta:
title: "MFC в цифрах и фактах"
description: "Оксана имя смелой девушки, которая первой согласилась принять участие в проекте&nbsp;18 апреля 2016 было создано сообщество Meet For Charity в фейсбуке&nbsp;Date For Charity&nbsp;именно так назывался проект изначально. Да, мы разыгрывали благотворительные свиданияСергей Капков&nbsp;поменял ход истории проекта. За встречу с ним были привлечены рекордные на тот момент 140 000 рублей на благотворительность&nbsp;Сентябрь 2016&nbsp;11:37, Кремниевая долина, один из многочисленных Старбаксов, Date For Charity меняется на Meet For Charity и, начиная с этого момента, проект становится таким, каким вы знаете его сейчасГор Нахапетян, Митя Хрусталёв, Алёна Долецкая, Кирилл Серебренников&nbsp;неполный список тех, кто первыми отправились на благотворительные встречи Meet For CharityПолмиллиона на благотворительность – именно за такую сумму "ушла с молотка" встреча с Михаилом Кучментом в поддержку фонда ОРБИ16 января 2017&nbsp;на DLD конференции в Мюнхене Meet For Charity занял 3-е призовое место премии CERprize, вручаемой лучшим социальным проектамПервый миллион,&nbsp;а точнее 1 200 000 рублей – мы привлекли за встречу с Дмитрием Гришиным, CEO Mail.ru Group, в поддержку фонда "Друзья", а затем были 1 400 000 рублей за встречу с Никой Белоцерковской, издаетелем журнала Sobaka.ru и любителем #кофекофе, в поддержку благотворительной организации "Ночлежка"&nbsp;11.12.2017&nbsp;Мы запустили meetforcharity.today&nbsp;"
image: "https://frontmfc.dev-vt2b.ru/files/5a2d817905648 */
const NewsPage = ({ items = [] }) => {
  const index = 0, setIndex = 0;// = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  let cups = [{ _id: '1', image: 'http://clipart-library.com/img/1695928.png', title: 'MFC X Даблби' },
  { _id: '2', image: 'http://clipart-library.com/img/1695928.png', title: 'Даблби X MFC' }];
  let brandList = [{ _id: '10', name: 'Metro', charity: '1 900 000 р' },
  { _id: '11', name: 'Wildberries', charity: '1 300 100 р' },
  { _id: '12', name: 'Ozon', charity: '1 900 000 р' },
  { _id: '13', name: 'Forbes Ontology', charity: '900 000 р' },
  { _id: '14', name: 'Нетология', charity: '600 000 р' },
  { _id: '15', name: 'Вкусвилл', charity: '500 000 р' }];
  if (!items.length) return null
  console.log('items', items)
  return (
    <div className='News'>
      <div className='Container'>
        <Swiper {...params}>
          {cups.map(el => (
            /*<Link to={`/news/${el._id}`} className='News__item' key={`news-${el._id}`}>*/
            <span className='News__item-body'>
              <dev>
                <span className='News__item-img-wrap'>
                  <img className='News__item-img' src={el.image} />
                  <span className='News__item-img-overlay' />
                  <h1 className='News__item-top-center-title'>{el.title}</h1>
                </span>
              </dev>
            </span>
            /*</Link>*/
          ))}
        </Swiper>
        <div className="News__row-big">
          Бренды, которые уже меняют мир к лучшему
      </div>
        <div className="list">
          {brandList.map(el => (
          <div className='News__list-row'>
            <div className='News__list-col'>{el.name}</div>
            <div className='News__list-col-right'>{el.charity}</div>
          </div>
        ))}
      </div>
      <div className='News__more'>
        <button className='Button Button_black'> {/*onClick={get.bind(this, { offset: items.length })} loading={fetching.button} */}
          Посмотреть всех партнеров
        </button>
      </div>
        <div className="News__row-extra-big">
          120 000 000 р
      </div>
        <div className="News__row-medium">
          собрали на благотворительность
      </div>
        <div className="News__row-extra-big">
          1 120 000
      </div>
        <div className="News__row-medium">
          человек
      </div>
        <div className="image">
          неск картинок
      </div>
        <Swiper {...params}>
          {cups.map(el => (
            /*<Link to={`/news/${el._id}`} className='News__item' key={`news-${el._id}`}>
              {<span className='News__item-body'>}*/
            <dev>
              <span className='News__item-img-wrap'>
                <img className='News__item-img' src={el.image} />
                <span className='News__item-img-overlay' />
              </span>
            </dev>
            /*</span>
          </Link>*/
          ))}
        </Swiper>
      <div className='News__more'>
        <button className='Button Button_black'> {/*onClick={get.bind(this, { offset: items.length })} loading={fetching.button} */}
          Посмотреть всех партнеров
        </button>
      </div>
        {/*<Swiper {...params}>
        {items.map(el => (
          <Link to={`/news/${el._id}`} className='News__item' key={`news-${el._id}`}>
            <span className='News__item-body'>
              <span className='News__item-img-wrap'>
                <img className='News__item-img' src={el.image} alt={el.title} />
                <span className='News__item-img-overlay' />
              </span>
              <span className='News__item-caption'>
                <span className='News__item-label Text'>{moment(el.created).from(moment()).charAt(0).toUpperCase() + moment(el.created).from(moment()).slice(1)}</span>
                <h1 className='News__item-title'>{el.title}</h1>
              </span>
            </span>
          </Link>
        ))}
        </Swiper>*/}
        {/*<Carousel activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="holder.js/800x400?text=First slide&bg=373940"
          alt="First slide"
        />
        <Carousel.Caption>
          <h3>First slide label</h3>
          <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="holder.js/800x400?text=Second slide&bg=282c34"
          alt="Second slide"
        />

        <Carousel.Caption>
          <h3>Second slide label</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="holder.js/800x400?text=Third slide&bg=20232a"
          alt="Third slide"
        />

        <Carousel.Caption>
          <h3>Third slide label</h3>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      </Carousel>*/}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({ ...state.news })
const mapDispatchToProps = dispatch => bindActionCreators({ get, getCount }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({}),
  lifecycle({
    componentWillMount() {
      this.props.get()
      this.props.getCount()
    }
  })
)(NewsPage)



// WEBPACK FOOTER //
// ./src/containers/News.jsx